import * as Tone from 'tone';


export const start = () => {
    Tone.Transport.start();
    Tone.context.resume();

}

export interface SoundUrlLocation {
    name: string;
    root: String;
    files: String;
}



export function getSoundUrls(sl: SoundUrlLocation) {

    return sl.files.split('\n')
        .map(f => f.trim())
        .filter(f => f.length)

        .map(f => f.replaceAll("\"", "")) // temp
        .map(f => f.split(":")[0].trim()) // temp

        .filter(f => !f.startsWith("//"))
        .map(f => `${sl.root}/${f}`)
        ;

}

export type BInstrument = ReturnType<typeof instr>

export const instr = (cb: () => void) => {

    let lastTime = 0;
    let loaded = false;

    // const synth = new Tone.Synth({
    //     envelope: {
    //         attack: 0,
    //         decay: 0,
    //         sustain: 1,
    //         release: 0.01,
    //     },
    // }).toDestination();

    // const soundUrls = getSoundUrls(DAnalogDK1Urls);
    const soundUrls = getSoundUrls(gam);
    // note: sampler doesn't like 0 as an index
    const urls: { [i: string]: string } = {};
    soundUrls.forEach((n, i) => { urls[(i + 1).toString()] = n });

    const sampler: Tone.Sampler = new Tone.Sampler({
        urls,
        volume: -3,
        // attack: 0,
        // release: 2,
        onload: () => {
            // sampler = loadingSampler;
            // onLoaded();
            loaded = true;
            cb();
        }
    }).toDestination();;


    return {
        play: (note: number, vel: number) => {
            const time = Math.max(0, Tone.now() - 1); // if we minu 1 it seems to trigger on time 🤷
            // const time = Math.max(0, Tone.now()); // if we minu 1 it seems to trigger on time 🤷
            // if (lastTime !== time) synth.triggerAttackRelease(note, "64n", Tone.now());
            // if (lastTime !== time && loaded) sampler.triggerAttack((Math.floor(note * soundUrls.length) + 1).toString(), time, vel);
            if ((lastTime !== time && loaded)) sampler.triggerAttack((Math.floor(note * soundUrls.length) + 1).toString(), time, vel);
            lastTime = time;


            // (sampler.context as any)._context.resume() // necessary for Safari
            // const ss = window.document.getElementById("aa")

            // if (!!ss) ss.innerHTML = lastTime.toString();
            // console.log(Tone.now());
        }
    }
}


const DAnalogDK1Urls = {
    name: "D Analog",
    root: 'https://s3-ap-southeast-2.amazonaws.com/ksounds/7945__menegass__mopho-dsi-analog-drum-kit',
    // root: "7945__menegass__mopho-dsi-analog-drum-kit",
    files: `
  127393__menegass__mopho-bd0.wav
  127394__menegass__mopho-bd1.wav
  127395__menegass__mopho-bd3.wav
  127396__menegass__mopho-bd4.wav
  127397__menegass__mopho-bd5.wav
  127398__menegass__mopho-bd6.wav
  127399__menegass__mopho-bd7.wav
  127400__menegass__mopho-bd8.wav
  127401__menegass__mopho-bd9.wav
  127402__menegass__mopho-cc0.wav
  127403__menegass__mopho-cc1.wav
  127404__menegass__mopho-cc2.wav
  127405__menegass__mopho-cc3.wav
  127406__menegass__mopho-cc5.wav
  127407__menegass__mopho-cc6.wav
  127408__menegass__mopho-cc7.wav
  127409__menegass__mopho-cc8.wav
  127410__menegass__mopho-cc9.wav
  127411__menegass__mopho-co0.wav
  127412__menegass__mopho-co1.wav
//   127413__menegass__mopho-hq0.wav
//   127414__menegass__mopho-hq1.wav
//   127415__menegass__mopho-hq2.wav
//   127416__menegass__mopho-hq3.wav
  127417__menegass__mopho-pop0.wav
  127418__menegass__mopho-pop1.wav
  127419__menegass__mopho-sd0.wav
  127420__menegass__mopho-sd1.wav
  127421__menegass__mopho-sd2.wav
  127422__menegass__mopho-sd3.wav
  127423__menegass__mopho-sd4.wav
  127424__menegass__mopho-microzap0.wav
  127425__menegass__mopho-microzap1.wav
  127426__menegass__mopho-microzap2.wav
  127427__menegass__mopho-microzap3.wav
  127428__menegass__mopho-microzap4.wav
  127429__menegass__mopho-noise0.wav
  127430__menegass__mopho-noise1.wav
  127431__menegass__mopho-noise2.wav
  127432__menegass__mopho-noise3.wav
  `};


const gam = {
    name: "GamelanPiano",
    root: 'https://ksounds.s3-ap-southeast-2.amazonaws.com/Komposer5/13389__wuola__toy-gamelan',
    // root: "7945__menegass__mopho-dsi-analog-drum-kit,
    files: `
    "210466__wuola__toygamelan-a4-04.wav": 435800,
    "210467__wuola__toygamelan-a4-03.wav": 468984,
    "210468__wuola__toygamelan-a4-02.wav": 488736,
    "210469__wuola__toygamelan-a4-01.wav": 528856,
    "210470__wuola__toygamelan-a5-04.wav": 469116,
    "210471__wuola__toygamelan-a5-03.wav": 440524,
    "210472__wuola__toygamelan-a5-02.wav": 462856,
    "210473__wuola__toygamelan-a5-01.wav": 471544,
    "210474__wuola__toygamelan-c-5-02.wav": 374252,
    "210475__wuola__toygamelan-c-5-01.wav": 446488,
    "210476__wuola__toygamelan-e5-03.wav": 358040,
    "210477__wuola__toygamelan-e5-04.wav": 364720,
    "210478__wuola__toygamelan-e5-01.wav": 451904,
    "210479__wuola__toygamelan-e5-02.wav": 402224,
    "210480__wuola__toygamelan-g5-03.wav": 374264,
    "210481__wuola__toygamelan-g5-04.wav": 379048,
    "210482__wuola__toygamelan-g5-01.wav": 439328,
    "210483__wuola__toygamelan-g5-02.wav": 203596,
    "210484__wuola__toygamelan-c-6-02.wav": 440516,
    "210485__wuola__toygamelan-c-6-01.wav": 524596,
    "210486__wuola__toygamelan-c-5-04.wav": 363176,
    "210487__wuola__toygamelan-c-5-03.wav": 379976,
    "210488__wuola__toygamelan-d5-02.wav": 520744,
    "210489__wuola__toygamelan-d5-01.wav": 524852,
    "210490__wuola__toygamelan-c-6-04.wav": 522416,
    "210491__wuola__toygamelan-c-6-03.wav": 522608,
    "210492__wuola__toygamelan-d5-04.wav": 522208,
    "210493__wuola__toygamelan-d5-03.wav": 523356,
      `};
